import styled from "@emotion/styled";
import { Button, IButtonProps } from "@teachers/ds-button";

export const DSEaselButton = styled(Button)<IButtonProps>`
  font-family: "Graphik", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 500;
`;
